export function ProfileCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-lg animate-pulse">
      <div className="flex">
        {/* Main content skeleton */}
        <div className="flex-1 min-w-0">
          {/* Header section */}
          <div className="relative px-7 pt-6 pb-5 bg-muted/20">
            {/* Avatar and info skeleton */}
            <div className="flex items-start gap-5">
              <div className="h-20 w-20 rounded-full bg-muted" />
              <div className="pt-1 space-y-2">
                <div className="h-6 w-48 rounded bg-muted" />
                <div className="h-4 w-32 rounded bg-muted" />
                <div className="h-3 w-24 rounded bg-muted" />
              </div>
            </div>
          </div>

          {/* Details grid skeleton */}
          <div className="grid grid-cols-2 gap-3 border-t border-border/50 px-7 py-5">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="flex items-start gap-2">
                <div className="h-8 w-8 rounded-full bg-muted" />
                <div className="space-y-1.5">
                  <div className="h-2 w-16 rounded bg-muted" />
                  <div className="h-3 w-24 rounded bg-muted" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tabs skeleton */}
        <div className="w-40 shrink-0 border-l border-border bg-muted/30 p-3">
          <div className="mb-2 px-2.5 h-2 w-16 rounded bg-muted" />
          <div className="flex flex-col gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-8 rounded-md bg-muted" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

